import { useQuery } from '@apollo/client'

import * as QUERIES from './queries'

export function useGetOriginations() {
  const { loading, error, data } = useQuery(QUERIES.GET_ORIGINATIONS)

  return { loading, error, data }
}
